import { render, staticRenderFns } from "./DeliveryPromotionForm.vue?vue&type=template&id=860bf7a4&scoped=true"
import script from "./DeliveryPromotionForm.vue?vue&type=script&lang=js"
export * from "./DeliveryPromotionForm.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPromotionForm.vue?vue&type=style&index=0&id=860bf7a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860bf7a4",
  null
  
)

export default component.exports